import * as actionTypes from "../constants/actionTypes";

// reducer initial state
export const initialState = {
  leftSidebarOpen: false,
  rightSidebarOpen: false,
  headerHidden: false,
  supportCardOpen: false,
  editor: false
};

// reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UI_OPEN_LEFT_SIDEBAR:
      return {
        ...state,
        leftSidebarOpen: true,
        rightSidebarOpen: false
      };
    case actionTypes.UI_OPEN_RIGHT_SIDEBAR:
      return {
        ...state,
        leftSidebarOpen: false,
        rightSidebarOpen: true
      };
    case actionTypes.UI_CLOSE_LEFT_SIDEBAR:
      return {
        ...state,
        leftSidebarOpen: false
      };
    case actionTypes.UI_CLOSE_RIGHT_SIDEBAR:
      return {
        ...state,
        rightSidebarOpen: false
      };
    case actionTypes.UI_SHOW_HEADER:
      return {
        ...state,
        headerHidden: false
      };
    case actionTypes.UI_HIDE_HEADER:
      return {
        ...state,
        headerHidden: true
      };
    case actionTypes.UI_SHOW_SUPPORT_CARD:
      return {
        ...state,
        supportCardOpen: true
      };
    case actionTypes.UI_HIDE_SUPPORT_CARD:
      return {
        ...state,
        supportCardOpen: false
      };
    case actionTypes.UI_SET_EDITOR:
      return {
        ...state,
        editor: action.payload.editor
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/ui.js